//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {listSymbol} from '~/constants/symbolsList';

export default {
  name: 'SelectCityModal',
  data() {
    return {
      searchAllCities: [],
      filterCities: [],
      search: '',
      cities: [],
      citiesFavorites: [],
      regions: [],
      activeRegion: {},


      stage: 1
    };
  },
  async mounted() {
    let {data: allCities} = await this.$api.agent.transport.get("cities?has_cdek_id=1");
    this.cities = allCities.cities;
    this.regions = allCities.regions;
    this.citiesFavorites = allCities.favorites || [];
    this.$refs.cityRef.focus();

    let searchAllCities = [];

    allCities.cities.map(city => {
      searchAllCities.push({
        ...city,
        name: city.name.replaceAll('ё', 'е'),
      })
    })

    this.searchAllCities = searchAllCities;
  },
  methods: {
    async onSetCity(id) {
      let body = {city_id: id};
      try {
        const {data: responseCheckout} = await this.$api.agent.transport.put(
          "cities/current",
          body
        );

        this.$cookies.set('accept_city', id);

        const activeCitySubDomain = (this.cities || []).find((t) => +t.id === +id)?.sub_domain || "";
        const currentFullPath = this.$route?.path || "";


        const locationHost = window.location?.host || "";
        const host = Boolean(locationHost.split(".")?.[0]?.indexOf("linza") <= -1) ?
          locationHost.split(".")?.slice(-(locationHost.split(".").length - 1)).join('.') :
          locationHost;
        const reloadUrl = `${window?.location?.protocol || "https:"}//${Boolean(activeCitySubDomain) ? `${activeCitySubDomain}.` : ""}${host}${currentFullPath}?c=${id}`


        location.href = reloadUrl;
      } catch (error) {
        console.log(error);
      }
    },
    onSearchChange() {
      let citySearch = [];
      let search = this.search.split('');

      search.map(symbol => {
        if (listSymbol[symbol]) {
          symbol = listSymbol[symbol];
        }
        citySearch.push(symbol);
      })
      this.onSearchValue(citySearch.join(""));
    },
    onSearchValue(string) {
      let cities = this.searchAllCities;

      string = string.replaceAll('ё', 'е');

      let filterCities = [];
      let regions = this.regions;

      cities.forEach(city => {
        if (city.name.toLowerCase().includes(string.toLowerCase())) {
          filterCities.push({...city, "region": regions.find(t => t.id === city.region_id).name})
        }
      })
      this.filterCities = filterCities;
    },

    setActiveRegion(region) {
      this.activeRegion = region;
      this.stage = 2;
    },

    isVisibleRegion: function (region) {
      const regionCities = (this.cities || []).filter((t) => +t.region_id === +region.id) || [];

      return Boolean(regionCities.length > 0)
    }
  },
  computed: {
    setActiveCities() {
      let cities = this.cities;
      let activeRegion = this.activeRegion;
      if (Object.keys(activeRegion).length > 0) {
        return cities.filter((t) => t.region_id === this.activeRegion.id);
      }
    },
  },
};
